import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-maximum-home-equity',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['./maximum-home-equity.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class MaximumHomeEquityComponent extends ButtonStepComponent implements OnInit {
  title: string = "Do you want your maximum amount of home equity at your lowest rate?";

  buttonList = [
    { text: 'Yes', value: 'yes', imageName: 'yes', default: true },
    { text: 'No', value: 'no', imageName: 'no-x' },
    { text: "Other Amount", value: "otherAmount", imageName: 'dont-know' },
  ];

  initStep() {
    if (this.communication.maxCashoutForm) {
      this.submit(this.buttonList[0]);
    }

    if (this.form.controls.formType.value == "cashout") {
      this.title = "Do you want your maximum amount of home equity at your lowest rate?"
    }
  }

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('maximumEquity', this.control);
  }
}
